export const SET_SNACKBAR_STATE = "SET_SNACKBAR_STATE"
export const SET_USER_HAS_CHANGES = "SET_USER_HAS_CHANGES"
export const SET_SHOW_DISCARD_CHANGES_DIALOG = "SET_SHOW_DISCARD_CHANGES_DIALOG"
